var React = require('react');

function SalesforceCloud (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#F6F2FD","key":0}),React.createElement("path",{"d":"M38.3846 51.7988H26.913C23.8696 51.7988 19 48.9364 19 42.4656C19 36.7618 24.4609 33.8583 27.7073 33.6507C27.9102 30.3322 31.4174 23.7988 39.6957 23.7988C47.9739 23.7988 50.8551 31.2656 51.2609 34.999C53.6957 34.999 61 36.1187 61 43.0875C61 50.0563 56.1304 51.7988 53.087 51.7988H52.3846","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M45.3874 57.3377V42.2607M45.3874 42.2607L41.6182 46.2517M45.3874 42.2607L49.1566 46.2517","stroke":"#8139F5","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

SalesforceCloud.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = SalesforceCloud;

SalesforceCloud.default = SalesforceCloud;
